import { NgModule } from '@angular/core';
import {  SpreadsheetGridComponent } from '../components/spreadsheet-grid.component';
import { AgGridModule } from "ag-grid-angular/main";
import { NumericEditor } from '../components/numeric-editor.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslatetionModule } from 'src/core/translation/modules/translation.module';
import { OnlyNumberModule } from 'src/core/directives/only-number.module';

@NgModule({
  declarations: [
    SpreadsheetGridComponent,
    NumericEditor
  ],
  imports:[
    CommonModule,
    FormsModule,
    AgGridModule.withComponents([NumericEditor]),
    TranslatetionModule,
    OnlyNumberModule
  ],
  exports:[
    SpreadsheetGridComponent,
    NumericEditor
  ]
})
export class SpreadsheetGridModule { }
